module.exports = __webpack_public_path__ + "assets/img/road-x.e47157e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/topics/road-x.jpg
// module id = e5uJ
// module chunks = 0